import React from 'react';
import styled, { css } from 'styled-components';
import type { SystemSize } from '~/theme';
import arrayToCss from '~/util/arrayToCss';

export type Props = {
  size?: 'small' | 'base';
  active?: boolean;
  label: string;
  margin?: Array<SystemSize | null>;
};

/**
 * Label with the blue background A1,B2 etc.
 */
const ActionLabel: React.FCC<Props> = ({
  dataTestId,
  active,
  size = 'base',
  label,
  margin,
  ...rest
}) => (
  <Container
    data-testid={dataTestId}
    $active={active}
    $size={size}
    $margin={margin}
    {...rest}
  >
    {label}
  </Container>
);

const Container = styled.span<{
  $size?: Props['size'];
  $active?: boolean;
  $margin?: Array<SystemSize | null>;
}>(
  ({ theme, $active, $size, $margin }) => css`
    color: ${theme.color($active ? 'white' : 'primary')};
    background-color: ${theme.color('primary', 'translucent')};
    margin-right: ${theme.space('xxs')};
    border-radius: ${theme.getTokens().border.radius.s};
    font-size: ${theme.fontSize($size === 'small' ? 'xxs' : 's')};
    font-weight: ${theme.fw('semiBold')};
    padding: ${theme.space('xxxs')} ${theme.space('xxs')};

    ${$margin &&
    css`
      margin-right: unset;
      margin: ${arrayToCss($margin, theme)};
    `}
  `,
);

export default ActionLabel;
